// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"f7b07037","827":"c95ae8c5","938":"8ab9f0db"}[chunkId] + ".chunk.css";
};